import {
  DisplayFormErrors,
  InputField,
  EfsMelcoModelsDesign,
  VerticalForm,
  Drawer as DrawerType,
  DebugForm,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { QueryObserverResult } from "react-query";
import { Col, DesignTokens, FullWidthSpace, Row, Title } from "melco-ui";
import { SavePublishHeader } from "../../header/SavePublishHeader";
import { useRevertDesign } from "../../../hooks/libraries/designs/useRevertDesign";
import { DesignUpdateField } from "./DesignUpdateField";
import { useDesignReferencesCount } from "../../../hooks/libraries/designs/useDesignReferencesCount";
import { DesignCanvas } from "./DesignCanvas";

const { spacings } = DesignTokens;

type DisplayDesignDetailFormProps = {
  design: EfsMelcoModelsDesign;
  refetch: () => Promise<QueryObserverResult<EfsMelcoModelsDesign, unknown>>;
  referencesDrawer?: DrawerType;
};

export const DisplayDesignDetailForm: React.FC<
  DisplayDesignDetailFormProps
> = ({ design, refetch, referencesDrawer }) => {
  const {
    id,
    publish_state: publishState,
    created_date: createdDate,
    updated_date: updatedDate,
    publish_date: publishDate,
    warning_list: warningList,
  } = design;

  const { t } = useTranslation();
  const [revertDesign, isLoading] = useRevertDesign(id!, refetch);

  const { total: referencesCount } = useDesignReferencesCount(id!);

  return (
    <>
      <SavePublishHeader
        revertAction={revertDesign}
        isCurrentlyReverting={isLoading}
        publishedState={publishState!}
        createdDate={createdDate!}
        updatedDate={updatedDate}
        publishedDate={publishDate}
        warnings={warningList ?? undefined}
        referencesCount={referencesCount}
        referencesDrawer={referencesDrawer}
      />

      <VerticalForm>
        <FullWidthSpace direction="vertical">
          <div>
            <DisplayFormErrors />

            <Row gutter={[spacings.middle, 0]}>
              <Col xs={24} md={12}>
                <InputField
                  name="name"
                  label={t("libraries.designs.detail.form.label.name")}
                />
              </Col>
              <Col xs={24} md={12}>
                <DesignUpdateField design={design} refetch={refetch} />
              </Col>
            </Row>

            <Title level={5}>
              {t("libraries.designs.detail.form.canvas.title")}
            </Title>

            <DesignCanvas design={design} />
          </div>
        </FullWidthSpace>
      </VerticalForm>

      {false && <DebugForm />}
    </>
  );
};
